import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import {
  MultipleLineTruncate,
  SingleLineTruncate,
} from '../../../../../components/LineTruncate';
import MerchantTag from '../../tags/MerchantTag';
import LowestPrice from '../../texts/LowestPrice';
import { BookingPageTagName } from '../../../../../domain/entities/BookingPage';
import css from './BookingPageCard.module.scss';
import { buildUrl } from 'src/utils/request-url';

interface Props {
  className?: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  href: string;
  tags: BookingPageTagName[];
  lowestPrice?: number;
  uniquePricing?: boolean;
}

const BookingPageCard = (props: Props) => {
  return (
    <div className={classNames(css.BookingPageCard, props.className)}>
      <Link
        href={buildUrl(props.href, 'next')} // Link互換(/reserveがあるなら削除する)再変換
        prefetch={false}
        className={css.BookingPageCard__Link}
      >
        <div>
          {props.thumbnailUrl && (
            <div className={css.BookingPageCard__Thumbnail}>
              <div
                className={css.BookingPageCard__ThumbnailImage}
                style={{ backgroundImage: `url(${props.thumbnailUrl})` }}
              />
            </div>
          )}
          <div className={css.BookingPageCard__Heading}>
            <SingleLineTruncate maxLine={2} text={props.title} />
          </div>
          <div className={css.BookingPageCard__Description}>
            <MultipleLineTruncate maxLine={3} text={props.description} />
          </div>
          <div className={css.BookingPageCard__Clearfix} />
        </div>
        <div className={css.BookingPageCard__Footer}>
          <div className={css.BookingPageCard__Tags}>
            {/* なぜかundefindが渡ってくることがあるのでチェックしている */}
            {props.tags &&
              props.tags.length > 0 &&
              props.tags.map((tag, i) => <MerchantTag key={i} status={tag} />)}
          </div>
          {props.lowestPrice !== undefined &&
            props.lowestPrice !== null &&
            props.uniquePricing !== undefined && (
              <div className={css.BookingPageCard__Price}>
                <LowestPrice
                  lowestPrice={props.lowestPrice}
                  uniquePricing={props.uniquePricing}
                />
              </div>
            )}
        </div>
      </Link>
    </div>
  );
};

export default BookingPageCard;
